import type {
    FishGroupLineage,
    FishGroupTransfer,
    LineageEdge,
    LineageFlatEntry,
    LineageNode,
} from '../historyTypes';
import type {
    FishGroupLineageDto,
    FishGroupTransferDto,
    LineageEdgeDto,
    LineageFlatEntryDto,
    LineageNodeDto,
} from '../types';

import { mapFishGroupBaseToDomain } from './detail';
import { asTransferOperationType } from './enumGuards';

// ---------------------------------------------------------------------------
// Lineage
// ---------------------------------------------------------------------------

export function mapFishGroupLineageToDomain(dto: FishGroupLineageDto): FishGroupLineage {
    return {
        rootId: dto.rootId,
        flat: {
            ancestors: dto.flat.ancestors.map(mapLineageFlatEntryToDomain),
            descendants: dto.flat.descendants.map(mapLineageFlatEntryToDomain),
        },
        graph: {
            nodes: dto.graph.nodes.map(mapLineageNodeToDomain),
            edges: dto.graph.edges.map(mapLineageEdgeToDomain),
        },
    };
}

function mapLineageFlatEntryToDomain(dto: LineageFlatEntryDto): LineageFlatEntry {
    return {
        depth: dto.depth,
        fishGroup: mapFishGroupBaseToDomain(dto.fishGroup),
    };
}

function mapLineageNodeToDomain(dto: LineageNodeDto): LineageNode {
    return {
        id: dto.id,
        depth: dto.depth,
        fishGroup: mapFishGroupBaseToDomain(dto.fishGroup),
        currentCageId: dto.currentCageId ?? null,
        currentCageName: dto.currentCageName ?? null,
    };
}

function mapLineageEdgeToDomain(dto: LineageEdgeDto): LineageEdge {
    return {
        sourceId: dto.sourceId,
        destinationId: dto.destinationId,
        transfer: mapTransferToDomain(dto.transfer),
    };
}

function mapTransferToDomain(dto: FishGroupTransferDto): FishGroupTransfer {
    return {
        id: dto.id,
        operationId: dto.operationId,
        operationType: asTransferOperationType(dto.operationType),
        sourceFishGroupId: dto.sourceFishGroupId,
        destinationFishGroupId: dto.destinationFishGroupId,
        transferDate: dto.transferDate,
        estimatedFishCount: dto.estimatedFishCount ?? null,
        reason: dto.reason ?? null,
        notes: dto.notes ?? null,
        revertedByOperationId: dto.revertedByOperationId ?? null,
    };
}
